// tslint:disable: deprecation

import { Injectable } from '@angular/core';
import { BodyOutputType, Toast, ToasterService } from 'angular2-toaster';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
  public displayInvalidationHoverMessage$ = new BehaviorSubject(null);
  public numberOfActiveToasts = 0;

  constructor(private readonly toasterService: ToasterService) {}

  // -------------------------------------
  //              TOASTS
  // -------------------------------------

  /**
   *
   * @param toast Toast object
   * @param buttonText Button Text
   * @param routerLink Router Link to navigate when clicking the button
   */
  public showToast(
    toast: Toast,
    buttonText: string = null,
    routerLink: string = null,
    bodyIsActionButton = false,
    injectedCallback = null
  ) {
    toast.bodyOutputType = BodyOutputType.TrustedHtml;
    const hasButton = buttonText !== null && routerLink !== null;
    const body = bodyIsActionButton ? `${toast.body || ''}` : `<p>${toast.body || ''}</p>`;

    if (hasButton) {
      toast = {
        ...toast,
        body: body + `<button class="btn_normal btn_outline_white btn_helper btn-toast-action">${buttonText}</button>`,
        clickHandler: (toaster, isCloseButton) => {
          const ev: any = event;
          if (ev) {
            const classes = ev.target.className.split(/\s/);

            const mainActionButtonClicked = classes.includes('btn-toast-action');
            if (mainActionButtonClicked && routerLink && routerLink.length > 0) {
              try {
                injectedCallback();
              } catch (err) {
                console.warn('Error in the injected callback for product setup', err);
              }
            }
            return true;
          }
        },
        onHideCallback: () => {
          if (this.numberOfActiveToasts > 0) {
            this.numberOfActiveToasts--;
          }
        }
      };
    }
    this.numberOfActiveToasts++;
    // toast.body = '';
    return this.toasterService.popAsync(toast);
  }

  public hideToasts() {
    this.toasterService.clear();
    this.numberOfActiveToasts = 0;
  }

  public hideToast(id) {
    this.toasterService.clear(id);
    this.numberOfActiveToasts--;
  }
}
